export const GET_OADATA_STARTED = 'GET_OADATA_STARTED';
export const GET_OADATA_SUCCESS = 'GET_OADATA_SUCCESS';
export const GET_OADATA_ERROR = 'GET_OADATA_ERROR';

export const GET_ORDERS_AGING_STARTED = 'GET_ORDERS_AGING_STARTED';
export const GET_ORDERS_AGING_SUCCESS = 'GET_ORDERS_AGING_SUCCESS';
export const GET_ORDERS_AGING_ERROR = 'GET_ORDERS_AGING_ERROR';